import React, { useState } from 'react';
import { Download, FileSpreadsheet, Loader2 } from 'lucide-react';
import { exportExcel, exportCSV } from '../services/api';
import toast from 'react-hot-toast';

export default function ExportButton({ filters = {} }) {
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [loadingCSV, setLoadingCSV] = useState(false);

  const handleExportExcel = async () => {
    setLoadingExcel(true);
    try {
      await exportExcel(filters);
      toast.success('Archivo exportado correctamente');
    } catch (err) {
      toast.error('Error al exportar: ' + err.message);
    } finally {
      setLoadingExcel(false);
    }
  };

  const handleExportCSV = async () => {
    setLoadingCSV(true);
    try {
      await exportCSV(filters);
      toast.success('CSV exportado correctamente');
    } catch (err) {
      toast.error('Error al exportar CSV: ' + err.message);
    } finally {
      setLoadingCSV(false);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={handleExportExcel}
        disabled={loadingExcel}
        className="btn-secondary flex items-center gap-2 text-sm"
      >
        {loadingExcel ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <Download className="w-4 h-4" />
        )}
        Exportar Excel
      </button>
      <button
        onClick={handleExportCSV}
        disabled={loadingCSV}
        className="btn-secondary flex items-center gap-2 text-sm"
      >
        {loadingCSV ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <FileSpreadsheet className="w-4 h-4" />
        )}
        CSV
      </button>
    </div>
  );
}
